export default __webpack_public_path__ + "static/media/discordbutton.0de32108.webp";